<template>
    <div class="section" dir="rtl">
        <div class="container">
            <div class="breadcrumb mb-10 text-bold" id="biography" > {{  $t('header.strategy.title') }} > {{ $t('header.strategy.launchStrategy.title') }}</div>
        </div>
    </div>
    <div class="container mt-5 text-center mb-5">

        <div dir="rtl" class="mb-4">
            <div class="title">
                {{  $t('header.strategy.title') }} 
            </div>
            <img :src="'img_strategy.jpg'" class="img-fluid img-thumbnail mb-4" alt="">

            <div class="card">
                <div class="card-body">
                    <div class="title">
                        الرؤية
                    </div>
                    <p>
                        عملاً بالتوصيات والتوجيهات التي جاء بها السيد رئيس الجمهورية تسعى الجزائر خلال السنوات الخمس المقبلة (2023-2027) إلى خلق مناخ سياسي واجتماعي واقتصادي مناهض للفساد، وإلى بناء دولة الحق والقانون تكرّس فيها مبادئ النزاهة والشفافية والمساءلة، وإلى وضع منظومة قانونية ومؤسساتية فعالة ومؤهلة.
                    </p>
                    <br>
                    <p>
                        تعد الاستراتيجية الوطنية للشفافية والوقاية من الفساد ومكافحته خطا توجيهيا لتفعيل المعايير الدولية والوطنية لمكافحة الفساد على مستوى المؤسسات والإدارات العمومية والقطاع الاقتصادي، التي تهدف إلى تعزيز تدابير الشفافية والوقاية من الفساد ومكافحته بصفة فعالة وبكفاءة عالية، مما سيترتب عنهما آثارا إيجابية في تغيير سلوك الأفراد والجماعات المستهدفة في الاستراتيجية.
                    </p>
                    <hr>
                    <div class="title">
                        المهمة
                    </div>
                    <p>
                        تسعى هذه الاستراتيجية إلى تحقيق مقاصد وطنية سامية تتمثل في:
                    </p>
                    <ul style="text-align: right">
                        <li> تجسيد دولة الحق والقانون؛</li>
                        <li>تكريس مبادئ الحكم الراشد؛</li>
                        <li> أخلقة الحياة العامة.</li>
                        <li> ترقية الديمقراطية التشاركية من أجل استعادة ثقة المواطن في مؤسسات الدولة</li>
                        <li>تحسين صورة الجزائر على المستوى الدولي</li>
                    </ul>
                    <p>
                        يتطلب تجسيد هذه الرؤية وتحقيق هذه المهمة، وضع استراتيجية شاملة وخطة عمل تنفيذية واضحة يتم في إطارها ضبط النشاطات والتدابير، وتحديد المسؤوليات وآجال التنفيذ والموارد اللازمة.
                    </p>
                    <hr>
                    <div class="title">
                        	الغايات الرئيسية والأهداف الاستراتيجية
                    </div>
                    <p>
                        تسعى الاستراتيجية الوطنية للشفافية والوقاية من الفساد ومكافحته إلى تحقيق خمسة غايات رئيسية، حيث ينبثق عنها 17 هدفا استراتيجيا، وستين 60 تدبيرا (مشروع).
                    </p>

                    <div class="accordion accordion-flush rtl-accordion mb-5" id="accordionFlushExample">
                        <div class="accordion-item">
                            <h2 class="accordion-header">
                                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#first_objective" aria-expanded="false" aria-controls="first_objective">
                                    {{  $t('header.strategy.launchStrategy.first_objective.title') }}
                                </button>
                            </h2>
                            <div id="first_objective" class="accordion-collapse collapse" data-bs-parent="#accordionFlushExample">
                                <div class="accordion-body" dir="rtl">
                                    <div class="first_goal_strategy">{{  $t('header.strategy.launchStrategy.first_objective.firstGoalStrategy.title') }}</div>
                                    <p>{{  $t('header.strategy.launchStrategy.first_objective.firstGoalStrategy.content') }}</p>
                                    <ul style="text-align: right;list-style-type: none!important;line-height: 1.6;">
                                        <li>{{  $t('header.strategy.launchStrategy.first_objective.firstGoalStrategy.one') }}</li>
                                        <li>{{  $t('header.strategy.launchStrategy.first_objective.firstGoalStrategy.two') }}</li>
                                        <li>{{  $t('header.strategy.launchStrategy.first_objective.firstGoalStrategy.three') }}</li>
                                        <li>{{  $t('header.strategy.launchStrategy.first_objective.firstGoalStrategy.four') }}</li>
                                        <li>{{  $t('header.strategy.launchStrategy.first_objective.firstGoalStrategy.five') }}</li>
                                        <li>{{  $t('header.strategy.launchStrategy.first_objective.firstGoalStrategy.six') }}</li>
                                        <li>{{  $t('header.strategy.launchStrategy.first_objective.firstGoalStrategy.seven') }}</li>
                                    </ul>

                                    <div class="first_goal_strategy">{{  $t('header.strategy.launchStrategy.first_objective.secondGoalStrategy.title') }}</div>
                                    <p>{{  $t('header.strategy.launchStrategy.first_objective.secondGoalStrategy.content') }}</p>
                                    <ul style="text-align: right;list-style-type: none!important;line-height: 1.6;">
                                        <li>{{  $t('header.strategy.launchStrategy.first_objective.secondGoalStrategy.eight') }}</li>
                                        <li>{{  $t('header.strategy.launchStrategy.first_objective.secondGoalStrategy.nine') }}</li>
                                        <li>{{  $t('header.strategy.launchStrategy.first_objective.secondGoalStrategy.ten') }}</li>
                                        <li>{{  $t('header.strategy.launchStrategy.first_objective.secondGoalStrategy.eleven') }}</li>
                                        <li>{{  $t('header.strategy.launchStrategy.first_objective.secondGoalStrategy.twelve') }}</li>
                                        <li>{{  $t('header.strategy.launchStrategy.first_objective.secondGoalStrategy.thirteen') }}</li>
                                    </ul>

                                    <div class="first_goal_strategy">{{  $t('header.strategy.launchStrategy.first_objective.thirdGoalStrategy.title') }}</div>
                                    <p>{{  $t('header.strategy.launchStrategy.first_objective.secondGoalStrategy.content') }}</p>
                                    <ul style="text-align: right;list-style-type: none!important;line-height: 1.6;">
                                        <li>{{  $t('header.strategy.launchStrategy.first_objective.thirdGoalStrategy.fourteen') }}</li>
                                        <li>{{  $t('header.strategy.launchStrategy.first_objective.thirdGoalStrategy.fifteen') }}</li>
                                        <li>{{  $t('header.strategy.launchStrategy.first_objective.thirdGoalStrategy.sixteen') }}</li>
                                        <li>{{  $t('header.strategy.launchStrategy.first_objective.thirdGoalStrategy.seventeen') }}</li>
                                    </ul>

                                    <div class="first_goal_strategy">{{  $t('header.strategy.launchStrategy.first_objective.fourthGoalStrategy.title') }}</div>
                                    <p>{{  $t('header.strategy.launchStrategy.first_objective.fourthGoalStrategy.content') }}</p>
                                    <ul style="text-align: right;list-style-type: none!important;line-height: 1.6;">
                                        <li>{{  $t('header.strategy.launchStrategy.first_objective.fourthGoalStrategy.eighteen') }}</li>
                                        <li>{{  $t('header.strategy.launchStrategy.first_objective.fourthGoalStrategy.nineteen') }}</li>
                                        <li>{{  $t('header.strategy.launchStrategy.first_objective.fourthGoalStrategy.twenty') }}</li>
                                        <li>{{  $t('header.strategy.launchStrategy.first_objective.fourthGoalStrategy.twentyOne') }}</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div class="accordion-item">
                            <h2 class="accordion-header">
                                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseTwo" aria-expanded="false" aria-controls="flush-collapseTwo">
                                    {{  $t('header.strategy.launchStrategy.second_objective.title') }}
                                </button>
                            </h2>
                            <div id="flush-collapseTwo" class="accordion-collapse collapse" data-bs-parent="#accordionFlushExample">
                                <div class="accordion-body" dir="rtl">
                                    <div class="first_goal_strategy">{{  $t('header.strategy.launchStrategy.second_objective.firstGoalStrategy.title') }}</div>
                                    <p>{{  $t('header.strategy.launchStrategy.second_objective.firstGoalStrategy.content') }}</p>
                                    <ul style="text-align: right;list-style-type: none!important;line-height: 1.6;">
                                        <li>{{  $t('header.strategy.launchStrategy.second_objective.firstGoalStrategy.twentyTwo') }}</li>
                                        <li>{{  $t('header.strategy.launchStrategy.second_objective.firstGoalStrategy.twentyThree') }}</li>
                                        <li>{{  $t('header.strategy.launchStrategy.second_objective.firstGoalStrategy.twentyFour') }}</li>
                                    </ul>

                                    <div class="first_goal_strategy">{{  $t('header.strategy.launchStrategy.second_objective.secondGoalStrategy.title') }}</div>
                                    <p>{{  $t('header.strategy.launchStrategy.second_objective.secondGoalStrategy.content') }}</p>
                                    <ul style="text-align: right;list-style-type: none!important;line-height: 1.6;">
                                        <li>{{  $t('header.strategy.launchStrategy.second_objective.secondGoalStrategy.twentyFive') }}</li>
                                        <li>{{  $t('header.strategy.launchStrategy.second_objective.secondGoalStrategy.twentySix') }}</li>
                                    </ul>

                                    <div class="first_goal_strategy">{{  $t('header.strategy.launchStrategy.second_objective.thirdGoalStrategy.title') }}</div>
                                    <p>{{  $t('header.strategy.launchStrategy.second_objective.thirdGoalStrategy.content') }}</p>
                                    <ul style="text-align: right;list-style-type: none!important;line-height: 1.6;">
                                        <li>{{  $t('header.strategy.launchStrategy.second_objective.thirdGoalStrategy.twentySeven') }}</li>
                                        <li>{{  $t('header.strategy.launchStrategy.second_objective.thirdGoalStrategy.twentyEight') }}</li>
                                        <li>{{  $t('header.strategy.launchStrategy.second_objective.thirdGoalStrategy.twentyNine') }}</li>
                                    </ul>

                                    <div class="first_goal_strategy">{{  $t('header.strategy.launchStrategy.second_objective.fourthGoalStrategy.title') }}</div>
                                    <p>{{  $t('header.strategy.launchStrategy.second_objective.fourthGoalStrategy.content') }}</p>
                                    <ul style="text-align: right;list-style-type: none!important;line-height: 1.6;">
                                        <li>{{  $t('header.strategy.launchStrategy.second_objective.fourthGoalStrategy.thirty') }}</li>
                                        <li>{{  $t('header.strategy.launchStrategy.second_objective.fourthGoalStrategy.thirtyOne') }}</li>
                                        <li>{{  $t('header.strategy.launchStrategy.second_objective.fourthGoalStrategy.thirtyTwo') }}</li>
                                    </ul>

                                    <div class="first_goal_strategy">{{  $t('header.strategy.launchStrategy.second_objective.fifthGoalStrategy.title') }}</div>
                                    <p>{{  $t('header.strategy.launchStrategy.second_objective.fifthGoalStrategy.content') }}</p>
                                    <ul style="text-align: right;list-style-type: none!important;line-height: 1.6;">
                                        <li>{{  $t('header.strategy.launchStrategy.second_objective.fifthGoalStrategy.thirtyThree') }}</li>
                                        <li>{{  $t('header.strategy.launchStrategy.second_objective.fifthGoalStrategy.thirtyFour') }}</li>
                                    </ul>



                                </div>
                            </div>
                        </div>
                        <div class="accordion-item">
                            <h2 class="accordion-header">
                                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseThree" aria-expanded="false" aria-controls="flush-collapseThree">
                                    {{  $t('header.strategy.launchStrategy.third_objective.title') }}
                                </button>
                            </h2>
                            <div id="flush-collapseThree" class="accordion-collapse collapse" data-bs-parent="#accordionFlushExample">
                                <div class="accordion-body" dir="rtl">
                                    <div class="first_goal_strategy">{{  $t('header.strategy.launchStrategy.third_objective.firstGoalStrategy.title') }}</div>
                                    <p>{{  $t('header.strategy.launchStrategy.third_objective.firstGoalStrategy.content') }}</p>
                                    <ul style="text-align: right;list-style-type: none!important;line-height: 1.6;">
                                        <li>{{  $t('header.strategy.launchStrategy.third_objective.firstGoalStrategy.thirtyFive') }}</li>
                                        <li>{{  $t('header.strategy.launchStrategy.third_objective.firstGoalStrategy.thirtySix') }}</li>
                                        <li>{{  $t('header.strategy.launchStrategy.third_objective.firstGoalStrategy.thirtySeven') }}</li>
                                        <li>{{  $t('header.strategy.launchStrategy.third_objective.firstGoalStrategy.thirtyEight') }}</li>
                                    </ul>

                                    <div class="first_goal_strategy">{{  $t('header.strategy.launchStrategy.third_objective.secondGoalStrategy.title') }}</div>
                                    <p>{{  $t('header.strategy.launchStrategy.third_objective.secondGoalStrategy.content') }}</p>
                                    <ul style="text-align: right;list-style-type: none!important;line-height: 1.6;">
                                        <li>{{  $t('header.strategy.launchStrategy.third_objective.secondGoalStrategy.thirtyNine') }}</li>
                                        <li>{{  $t('header.strategy.launchStrategy.third_objective.secondGoalStrategy.forty') }}</li>
                                        <li>{{  $t('header.strategy.launchStrategy.third_objective.secondGoalStrategy.fortyOne') }}</li>
                                        <li>{{  $t('header.strategy.launchStrategy.third_objective.secondGoalStrategy.fortyTwo') }}</li>
                                    </ul>

                                    <div class="first_goal_strategy">{{  $t('header.strategy.launchStrategy.third_objective.thirdGoalStrategy.title') }}</div>
                                    <p>{{  $t('header.strategy.launchStrategy.third_objective.thirdGoalStrategy.content') }}</p>
                                    <ul style="text-align: right;list-style-type: none!important;line-height: 1.6;">
                                        <li>{{  $t('header.strategy.launchStrategy.third_objective.thirdGoalStrategy.fortyThree') }}</li>
                                        <li>{{  $t('header.strategy.launchStrategy.third_objective.thirdGoalStrategy.fortyFour') }}</li>
                                        <li>{{  $t('header.strategy.launchStrategy.third_objective.thirdGoalStrategy.fortyFive') }}</li>
                                    </ul>

                                </div>
                            </div>
                        </div>
                        <div class="accordion-item">
                            <h2 class="accordion-header">
                                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#forth_objective" aria-expanded="false" aria-controls="forth_objective">
                                    {{  $t('header.strategy.launchStrategy.forth_objective.title') }}
                                </button>
                            </h2>
                            <div id="forth_objective" class="accordion-collapse collapse" data-bs-parent="#accordionFlushExample">
                                <div class="accordion-body" dir="rtl">
                                    <div class="first_goal_strategy">{{  $t('header.strategy.launchStrategy.forth_objective.firstGoalStrategy.title') }}</div>
                                    <p>{{  $t('header.strategy.launchStrategy.forth_objective.firstGoalStrategy.content') }}</p>
                                    <ul style="text-align: right;list-style-type: none!important;line-height: 1.6;">
                                        <li>{{  $t('header.strategy.launchStrategy.forth_objective.firstGoalStrategy.fortySix') }}</li>
                                        <li>{{  $t('header.strategy.launchStrategy.forth_objective.firstGoalStrategy.fortySeven') }}</li>
                                        <li>{{  $t('header.strategy.launchStrategy.forth_objective.firstGoalStrategy.fortyEight') }}</li>
                                        <li>{{  $t('header.strategy.launchStrategy.forth_objective.firstGoalStrategy.fortyNine') }}</li>
                                        <li>{{  $t('header.strategy.launchStrategy.forth_objective.firstGoalStrategy.fifty') }}</li>
                                    </ul>

                                    <div class="first_goal_strategy">{{  $t('header.strategy.launchStrategy.forth_objective.secondGoalStrategy.title') }}</div>
                                    <p>{{  $t('header.strategy.launchStrategy.forth_objective.secondGoalStrategy.content') }}</p>
                                    <ul style="text-align: right;list-style-type: none!important;line-height: 1.6;">
                                        <li>{{  $t('header.strategy.launchStrategy.forth_objective.secondGoalStrategy.fiftyOne') }}</li>
                                        <li>{{  $t('header.strategy.launchStrategy.forth_objective.secondGoalStrategy.fiftyTwo') }}</li>
                                        <li>{{  $t('header.strategy.launchStrategy.forth_objective.secondGoalStrategy.fiftyThree') }}</li>
                                    </ul>

                                    <div class="first_goal_strategy">{{  $t('header.strategy.launchStrategy.forth_objective.thirdGoalStrategy.title') }}</div>
                                    <p>{{  $t('header.strategy.launchStrategy.forth_objective.thirdGoalStrategy.content') }}</p>
                                    <ul style="text-align: right;list-style-type: none!important;line-height: 1.6;">
                                        <li>{{  $t('header.strategy.launchStrategy.forth_objective.thirdGoalStrategy.fiftyFour') }}</li>
                                        <li>{{  $t('header.strategy.launchStrategy.forth_objective.thirdGoalStrategy.fiftyFive') }}</li>
                                        <li>{{  $t('header.strategy.launchStrategy.forth_objective.thirdGoalStrategy.fiftySix') }}</li>
                                    </ul>

                                </div>
                            </div>
                        </div>
                        <div class="accordion-item">
                            <h2 class="accordion-header">
                                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#fifth_objective" aria-expanded="false" aria-controls="fifth_objective">
                                    {{  $t('header.strategy.launchStrategy.fifth_objective.title') }}
                                </button>
                            </h2>
                            <div id="fifth_objective" class="accordion-collapse collapse" data-bs-parent="#accordionFlushExample">
                                <div class="accordion-body" dir="rtl">
                                    <div class="first_goal_strategy">{{  $t('header.strategy.launchStrategy.fifth_objective.firstGoalStrategy.title') }}</div>
                                    <p>{{  $t('header.strategy.launchStrategy.fifth_objective.firstGoalStrategy.content') }}</p>
                                    <ul style="text-align: right;list-style-type: none!important;line-height: 1.6;">
                                        <li>{{  $t('header.strategy.launchStrategy.fifth_objective.firstGoalStrategy.fiftySeven') }}</li>
                                        <li>{{  $t('header.strategy.launchStrategy.fifth_objective.firstGoalStrategy.fiftyEight') }}</li>
                                    </ul>

                                    <div class="first_goal_strategy">{{  $t('header.strategy.launchStrategy.fifth_objective.secondGoalStrategy.title') }}</div>
                                    <p>{{  $t('header.strategy.launchStrategy.fifth_objective.secondGoalStrategy.content') }}</p>
                                    <ul style="text-align: right;list-style-type: none!important;line-height: 1.6;">
                                        <li>{{  $t('header.strategy.launchStrategy.fifth_objective.secondGoalStrategy.fiftyNine') }}</li>
                                        <li>{{  $t('header.strategy.launchStrategy.fifth_objective.secondGoalStrategy.sixty') }}</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>

        <hr>

        <div class="mt-5" dir="rtl">
            <div class="card">
                <h5 class="card-header">آليات التنفيذ والرصد والتقييم</h5>
                <div class="card-body">
                    <p>
                        يتطلب التنفيذ الفعال للاستراتيجية الوطنية للشفافية والوقاية من الفساد ومكافحته تنسيق جهود كل الفاعلين من دوائر وزارية والقطاع الاقتصادي والجهات القضائية والمجتمع المدني بمختلف أطيافه، لتجسيد التدابير التي تتضمنها خطة التنفيذ ورصد أي خلل قد يؤدي إلى توقفه أو تأخره.
                    </p>
                    <br>
                    <p>
                        كما تتم المتابعة بشكل دوري عبر جمع المعلومات والبيانات التي تساعد في قياس مدى تجسيد خطة التنفيذ ومدى تقدمها نحو تحقيق أهداف الاستراتيجية ضمن الجدول الزمني المحدد.
                    </p>
                    <br>
                    <p>
                        كما أن توفير الموارد البشرية والمالية اللازمة لتنفيذ هذه الاستراتيجية هو شرط ضروري لنجاحها، من خلال تخصيص غلاف مالي خاص بالاستراتيجية، مع ادراج بنود في ميزانيات القطاعات الوزارية لتمويل التدابير المنصوص عليها ضمن الاستراتيجية.
                    </p>
                    <br>
                    <p>
                        في هذا الصدد، تتولى السلطة العليا للشفافية والوقاية من الفساد ومكافحته مهام مراجعة التقارير المتعلقة بالتنفيذ والرصد والتقييم وإقرارها ونشرها، واعتماد خطط العمل السنوية، وإدخال أي تعديلات جوهرية على الاستراتيجية وخطط تنفيذها، عند الاقتضاء.
                    </p>
                    <br>
                    <p>
                        تعتمد عملية المتابعة والتقييم على مجموعة من المؤشرات التي يمكن من خلالها قياس التقدم المحرز في تنفيذ الاستراتيجية وقياس الأثر المترتب عن ذلك.
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "launchStrategy"
    }
</script>

<style scoped>
    .first_goal_strategy{
        text-align: right!important;
        color: #254C31!important;
        font-weight: bold!important;
        font-size: 16px!important;
    }
    .rtl-accordion .accordion-button::after {
        margin-left: 0 !important; /* Remove default left margin */
        margin-right: auto; /* Push arrow to the right */
    }
    .rtl-accordion .accordion-button {
        text-align: right;
        direction: rtl;
    }
    ul.no-bullets {
        list-style-type: none;
        margin: 0;
        padding: 0;
    }
    .mot_president{
        color: rgba(50, 54, 57, 0.83);
    }
    .nav-link{
        color: rgba(80, 84, 87, 0.8) !important;
    }
    .active{
        color: rgba(28, 28, 28, 0.96)!important;
    }
    .section {
        display: flex;
        align-items: center;
        font-size: var(--xs-font-size);
        font-weight: bold;
        background: var(--secondary-background-color);
        padding: calc(7/16 * var(--default-size-unit)) calc((100vw - 1920px)/2 +  var(--body-padding));
        border-top: var(--input-border);
        border-bottom: var(--input-border);
        font-family: Cairo,sans-serif;
    }
    .breadcrumb{
        text-decoration: none!important;
        margin: 0;
        color: #37414D;
        font-family: Cairo,sans-serif!important;
    }
    .title {
        width: 100%;
        display: flex;
        align-items: center;
        font-size: var(--l-font-size);
        font-weight: 700;
    }
    .title::before {
        content: ' ';
        display: block;
        -webkit-margin-end: var(--default-size-unit);
        margin-inline-end: var(--default-size-unit);
        width: calc(35/16 * var(--default-size-unit));
        height: calc(8/16 * var(--default-size-unit));
        background: var(--primary-text-color);
        min-width: calc(35/16 * var(--default-size-unit));
    }
    .back-gray{
        background-color: #E7E9EB;
        padding: 15px 15px;
    }
    .back-gray p{
        line-height: 200%;
    }
</style>